/**
 * คำตอบบอท (Answers) — รวมที่เดียว: FAQ (คำถาม-คำตอบตรงๆ) + เทมเพลต (ข้อความมี {{ตัวแปร}})
 * ทั้งคู่ใช้ CrudManager กลาง (DRY) — หน้านี้เป็นมุมมองรวมให้แอดมินเห็นคำตอบทั้งหมดในที่เดียว
 */
import FaqPage from './FaqPage';
import ReplyTemplatesPage from './ReplyTemplatesPage';
import LeadTimesCard from './LeadTimesCard';

export default function AnswersPage() {
  return (
    <div className="space-y-10">
      <div className="text-sm bg-blue-50 border border-blue-200 rounded-lg p-3 text-blue-900">
        <strong>คำตอบบอทมี 2 แบบ:</strong> <b>FAQ</b> = ตอบตรงๆ ตามคำที่ลูกค้าพิมพ์ · <b>เทมเพลต</b> = ข้อความที่มี {'{{ตัวแปร}}'} ให้บอตเติมค่าจริง (ราคา/สี/ไซซ์).
        แก้ได้ทั้งคู่ด้านล่าง — ทดสอบผลที่แท็บ “ทดสอบบอต”
      </div>
      <LeadTimesCard />
      <FaqPage />
      <ReplyTemplatesPage />
    </div>
  );
}
